'use client';

/**
 * @deprecated Avoid using this function as this module is deprecated.
 */
/* eslint-disable @typescript-eslint/no-this-alias */
// Polyfill a limited subset of the Web Animations API.
export function waapiFallback(keyframes: any) {
  // @ts-ignore-next-line
  const el = this;

  function applyStyles() {
    const styleObject = Array.isArray(keyframes)
      ? keyframes[keyframes.length - 1]
      : keyframes;

    Object.entries(styleObject).forEach(([key, value]) => {
      el.style[key] = Array.isArray(value) ? value[value.length - 1] : value;
    });
  }

  const animation: any = {
    playState: 'running',
    stop: () => {
      // @ts-ignore-next-line
      this.playState = 'paused';
    },
    cancel: () => {
      // @ts-ignore-next-line
      this.playState = 'finished';
    },
    commitStyles: applyStyles,
  };

  applyStyles();

  setTimeout(() => {
    if (animation.onfinish) {
      animation.onfinish();
    }
  }, 0);

  return animation;
}
